import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { PurchaseInvoiceLine, PurchaseInvoiceLineCreate, PurchaseInvoiceLineFilter } from '../data/purchaseInvoiceLine';

export function createPurchaseInvoiceLineService(client: AxiosInstance) {
  return createCrudService<PurchaseInvoiceLine, PurchaseInvoiceLineCreate, PurchaseInvoiceLineFilter>(
    client,
    '/purchase/PurchaseInvoiceLine',
    'id',
  );
}

export type PurchaseInvoiceLineService = CrudService<PurchaseInvoiceLine, PurchaseInvoiceLineCreate, PurchaseInvoiceLineFilter>;
